import { index, Options } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $hideBorder: boolean;
  $borderColor?: string;
}>`
  border-bottom: ${({ theme, $hideBorder, $borderColor }) =>
    $hideBorder
      ? 'none'
      : `1px solid ${$borderColor ?? theme.palette.divider}`};
`;

export const ContentContainer = styled.div<{
  $isElectronMac: boolean;
  $menuDisplayed: boolean;
  $smallLeftPadding: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  position: sticky;
  top: 0;
  z-index: ${index(Options.TOPBAR)};

  min-height: 4.8rem;
  padding: ${({ theme, $smallLeftPadding }) =>
    `${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing($smallLeftPadding ? 3 : 4)}`};

  color: ${({ theme }) => theme.palette.grey[700]};

  ${({ theme, $isElectronMac, $menuDisplayed }) =>
    $isElectronMac &&
    css`
      -webkit-app-region: drag;
      padding: ${`${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(19)}`};

      ${theme.breakpoints.up(theme.breakpoints.values.md)} {
        padding: ${$menuDisplayed
          ? `${theme.spacing(1)} ${theme.spacing(3)}`
          : `${theme.spacing(1)} ${theme.spacing(3)}
          ${theme.spacing(1)} ${theme.spacing(19)}`};
      }
    `};
`;

export const SmallScreenIconButton = styled.div`
  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: none;
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const SmallScreenUpIconButton = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: block;
  }
`;

export const Content = styled.div`
  flex: 1;
`;

export const MobileNavigation = styled.div`
  display: none;
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};

  border-top: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: block;
    `}
`;
